/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import {
  NOTIFICATION_NUMBER,
  LOGIN,
  LOGOUT,
  EDIT_CONTACT_DETAILS,
  PR_PATIENT_ID,
  HEAD_CLINIC_DATA,
  CLINICS_DATA,
  PR_PATIENT_DATA,
  CONSTANTS_DATA,
  SET_USER_BANK_DETAILS,
  SET_PR_PATIENT_WARNINGS,
  SET_ALL_PROVIDERS_FROM_HEAD_CLINIC,
  BOOKING_FILTERS,
  STOCK_FILTERS,
  PRACTITIONER_CONSENT_FILTERS,
} from '../constants/commonConstant';

export const notificationNumber = (data) => ({
  type: NOTIFICATION_NUMBER,
  payload: data,
});

// user login
export const loginUser = (data) => ({
  type: LOGIN,
  payload: data,
});

// user logout
export const logoutUser = () => ({
  type: LOGOUT,
});
export const editContactDetailsPR = (data) => ({
  type: EDIT_CONTACT_DETAILS,
  payload: data,
});

export const setPrPatientId = (data) => ({
  type: PR_PATIENT_ID,
  payload: data,
});

export const setHeadClinicData = (data) => ({
  type: HEAD_CLINIC_DATA,
  payload: data,
});

export const setClinicsData = (data) => ({
  type: CLINICS_DATA,
  payload: data,
});

export const setPrPatientData = (data) => ({
  type: PR_PATIENT_DATA,
  payload: data,
});

export const setConstantsData = (data) => ({
  type: CONSTANTS_DATA,
  payload: data,
});

export const setUserBankDetails = (data) => ({
  type: SET_USER_BANK_DETAILS,
  payload: data,
});

export const setPrPatientWarnings = (data) => ({
  type: SET_PR_PATIENT_WARNINGS,
  payload: data,
});

export const setProvidersFromHeadClinic = (payload) => ({
  type: SET_ALL_PROVIDERS_FROM_HEAD_CLINIC,
  payload,
});

export const setBookingFilters = (payload) => ({
  type: BOOKING_FILTERS,
  payload,
});

export const setStockFilters = (payload) => ({
  type: STOCK_FILTERS,
  payload,
});

export const setPractitionerConsentFilters = (payload) => ({
  type: PRACTITIONER_CONSENT_FILTERS,
  payload,
});
